import { IViolation } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from './copysource';
import { IAttribute } from 'app/model/base/annotation';

import { Constants } from 'app/shared/shared-constants';
import { RestResourceDataset } from 'app/model/dataset/rest-resource.dataset';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from '../parameter-config';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Owned, stringsAreEqualCaseInsensitive } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.rest.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(RestResourceDataset) }
})
export class RestResourceCopySource extends CopySource {
    public static readonly REQUEST_TIMEOUT: IAttribute;
    public static readonly REQUEST_INTERVAL: IAttribute;
    public static readonly METHOD: IAttribute;
    public static readonly BODY: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'REQUEST_TIMEOUT',
        display: stringResources.ModelName_Request_Timeout,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:01:40';

    @Metamodel.attribute({
        templatable: true,
        association: 'REQUEST_INTERVAL',
        display: stringResources.ModelName_REST_Source_Request_Interval,
        accepts: ['String']
    })
    public requestInterval?: number = 10;

    @Metamodel.attribute({
        templatable: true,
        association: 'METHOD',
        display: stringResources.Dataset_RequestMethod
    })
    public requestMethod?: string = 'GET';

    @Metamodel.attribute({
        templatable: true,
        association: 'BODY',
        display: stringResources.Dataset_RequestBody,
        constraint: {
            validator: RestResourceCopySource.validateRequestBody
        }
    })
    public requestBody?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_AdditionalHeaders,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public additionalHeaders?: ParameterConfig[] = [];

    @Metamodel.attribute({
        display: stringResources.Dataset_PaginationRules,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public paginationRules?: ParameterConfig[] = [];

    public isV2: boolean;

    public containsRequestBodyInGetRequests: boolean = false;

    constructor() {
        super();
        const rfc5988 = Owned.create<ParameterConfig>(ParameterConfig.MODEL, this);
        rfc5988.name = 'supportRFC5988';
        rfc5988.value = 'true';
        this.paginationRules.push(rfc5988);
    }

    public static validateRequestBody(copySource?: RestResourceCopySource): IViolation[] {
        // existing resource may contain GET + request body setting, which is an unsupported scenario in runtime
        const violations: IViolation[] = [];
        if (copySource && copySource.isV2 && copySource.containsRequestBodyInGetRequests &&
            stringsAreEqualCaseInsensitive(copySource.requestMethod, 'GET') && copySource.requestBody) {
            violations.push({
                message: () => stringResources.Rest_Get_Request_Body_ValidationError
            });
        }
        return violations;
    }
}
